import React from 'react';
import { useStyles } from './PublicProjectDataPoint.styles';
import LabelWithIcon from './LabelWithIcon';

interface DataPointProps {
  label: string;
  icon?: React.ReactNode;
  text: string;
}

const PublicProjectDataPoint = ({ label, icon, text }: DataPointProps) => {
  const classes = useStyles();

  return (
    <div>
      <LabelWithIcon label={label} icon={icon} />
      <div
        className={classes.dataPointText}
        style={!icon ? { marginTop: '7px', marginLeft: '0' } : {}}
      >
        {text}
      </div>
    </div>
  );
};

export default PublicProjectDataPoint;
